module.exports = __webpack_public_path__ + "static/media/home_screen_background.d96c0278.jpg";